// React
import { useEffect, useState } from 'react';

// PrimeReact
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

// Formik
import { useFormik } from 'formik';
import formikValidation from '../formikValidation';

// Global
// global
import {
  printToast,
  getFormErrorMessage,
  summaryAlteracaoSucessoPadrao,
  detailAlteracaoSucessoPadrao
} from "../../../config/global";

// Seplag
import RotuloSeplag from '../../../components/RotuloSeplag';
import ModalSeplag from '../../../components/ModalSeplag';

// Service
import useSelecaoAmparoLegal, { SelecaoAmparoLegalRender } from '../../../components/SelecaoAmparoLegal'
import {
  atualizar as atualizarManterObrigacao,
  pesquisaAll as listaObrigacaoAll
} from '../../../service/manterObrigacao';

import { pesquisarAll } from '../../../service/Orgao'
import { Button } from 'primereact/button';

const ModalDetalheObrigacao = ({ onFechar, handlerHide, showForm, form, edit, atualizaTabela }) => {

  const [optionsOrgaoDeOrigemDaObrigacao, setOptionsOrgaoDeOrigemDaObrigacao] = useState()
  const amparo = useSelecaoAmparoLegal({ amparos: form.listaAmparoLegalObrigacao })

  useEffect(() => {
    pesquisarAll().then(res => {
      setOptionsOrgaoDeOrigemDaObrigacao(res)
    })
  }, [])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,
    validate: (data) => {
      return formikValidation(data)
    },
    onSubmit: async (data) => {
      let dadosRequestBody = { ...data }
      const { idenObrigacao } = data;
      dadosRequestBody.listaAmparoLegalObrigacao = amparo.justificativasSelecionada
      dadosRequestBody.amparoLegal = null
      dadosRequestBody.listaAmparoLegalObrigacao = dadosRequestBody.listaAmparoLegalObrigacao.map(function (element2) {
        return {
          obrigacao: {
            idenObrigacao
          },
          amparoLegal: { ...element2 }
        }
      })
      await atualizarManterObrigacao(idenObrigacao, dadosRequestBody).then(() => {
        // listaObrigacaoAll().then((res) => {
        //   let dados = res.content;
        //   atualizaTabela(dados.map(function (element) {
        //     let novoElement = {
        //       ...element,
        //       numCpfFormatado: element.numrCpf ? element.numrCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : '',
        //       dataQuitacao: element.dataQuitacao ? element.dataQuitacao : '',
        //       dataCancelamento: element.dataCancelamento ? element.dataCancelamento : '',
        //       codgValidadorObrigacao: element.codgValidadorObrigacao ? element.codgValidadorObrigacao : '',
        //       descComplemento: element.descComplemento ? element.descComplemento : '',
        //       nomeTipoCertidao: element.nomeTipoCertidao ? element.nomeTipoCertidao : '',
        //       flagSituacao: element.flagSituacao ? element.flagSituacao : '',
        //       listaAmparoLegalObrigacao: element.listaAmparoLegalObrigacao.map(function (element2) {
        //         return { ...element2.amparoLegal }
        //       })
        //     }
        //     if (element.amparoLegal) {
        //       novoElement.listaAmparoLegalObrigacao.push(element.amparoLegal)
        //     }
        //     return novoElement
        //   }));
        // })
        atualizaTabela()
        printToast({ summary: summaryAlteracaoSucessoPadrao, detail: detailAlteracaoSucessoPadrao });
        onFechar();
      });
    },
  });

  return (
    <ModalSeplag titulo={edit ? "Editar Crédito Salarial" : "Cadastrar Certidão Salarial"} fechar={onFechar} tamanho={"80rem"} header="Detalhes da Obrigação" visible={showForm} onHide={handlerHide} type="NONE" edit={edit}>

      <form onSubmit={formik.handleSubmit} className="p-grid">
        <RotuloSeplag obrigatorio nome="CPF do Beneficiário" cols="12 6">
          <InputText disabled value={formik.values.numCpfFormatado} id='numCpfFormatado' />
          {getFormErrorMessage("numCpfFormatado", formik)}
        </RotuloSeplag>

        <RotuloSeplag nome="Beneficiário" cols="12 6">
          <InputText value={formik.values.pessoa.nomePessoa} disabled />
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="Órgão de Origem" cols="12 8">
          <Dropdown
            optionLabel="descOrgao"
            id="orgao"
            filter
            value={formik.values.orgao}
            options={optionsOrgaoDeOrigemDaObrigacao}
            onChange={(e) => formik.handleChange(e)}
            placeholder="Selecione"
            autoFocus={true}
          />
          {getFormErrorMessage("orgao", formik)}
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="Tipo  Certidão" cols="12 4">
          <InputText value={formik.values.tipoCertidao.nomeTipoCertidao} id="nomeTipoCertidao" disabled />
          {getFormErrorMessage("nomeTipoCertidao", formik)}
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="Valor Bruto" cols="12 2">
          <InputNumber value={Number(formik.values.valrBruto)} disabled />
          {getFormErrorMessage("valrBruto", formik)}
        </RotuloSeplag>

        {/* <RotuloSeplag obrigatorio nome="Emolumentos" cols="12 2">
          <InputNumber disabled value={Number(formik.values.valrEmolumento)} />
          {getFormErrorMessage("valrEmolumento", formik)}
        </RotuloSeplag> */}

        <RotuloSeplag obrigatorio nome="Valor I.R" cols="12 2">
          <InputNumber disabled value={Number(formik.values.valrIr)} />
          {getFormErrorMessage("valrIr", formik)}
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="Valor Honorário" cols="12 2">
          <InputNumber disabled value={Number(formik.values.valrHonorario)} />
          {getFormErrorMessage("valrHonorario", formik)}
        </RotuloSeplag>

        {/* <RotuloSeplag obrigatorio nome="Outro Valor" cols="12 2">
          <InputNumber disabled value={Number(formik.values.valrOutro)} />
          {getFormErrorMessage("valrOutro", formik)}
        </RotuloSeplag> */}

        <RotuloSeplag obrigatorio nome="Valor Líquido" cols="12 2">
          <InputNumber disabled value={(formik.values.valrBruto - formik.values.valrEmolumento - formik.values.valrIr - formik.values.valrHonorario - formik.values.valrOutro)} />
          {getFormErrorMessage("valrLiquido", formik)}
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="Data da Quitação" cols="12 3">
          <InputText disabled value={formik.values.dataQuitacao} />
          {getFormErrorMessage("dataQuitacao", formik)}
        </RotuloSeplag>

        {/* <RotuloSeplag obrigatorio nome="Data do Cancelamento" cols="12 3">
          <InputText disabled value={formik.values.dataCancelamento} />
          {getFormErrorMessage("dataCancelamento", formik)}
        </RotuloSeplag> */}

        {/* <RotuloSeplag obrigatorio nome="Código Validador" cols="12 3">
          <InputText disabled value={formik.values.codgValidadorObrigacao} />
          {getFormErrorMessage("codgValidadorObrigacao", formik)}
        </RotuloSeplag> */}

        {/* <RotuloSeplag obrigatorio nome="Situação" cols="12 3">
          <InputText disabled value={formik.values.flagSituacao} />
          {getFormErrorMessage("flagSituacao", formik)}
        </RotuloSeplag> */}

        <RotuloSeplag obrigatorio nome="Complemento" cols="12">
          <InputText disabled id="descComplemento" value={formik.values.descComplemento} />
        </RotuloSeplag>

        <SelecaoAmparoLegalRender  {...amparo} />

        <div className="p-col-12 p-md-3">
          <Button
            label={edit ? 'Editar' : "Enviar"}
            icon={edit ? "pi pi-pencil" : "pi pi-check"}

            className="p-button-raised margin-app-entre-button"
            type="submit"
          />
        </div>
        <div className="p-col-12 p-md-3">
          <Button
            type='button'
            label="Cancelar"
            icon="pi pi-times"
            onClick={onFechar}
            className="p-button-outlined p-button-danger p-mb-1"
          />
        </div>

      </form>
    </ModalSeplag>
  );
}

export default ModalDetalheObrigacao;
